import { Controller } from "@hotwired/stimulus"

// Comportamentos da caixa de entrada + thread do chat (story 1.4).
// Responsabilidades:
//  - enter-to-send (Enter sem shift submete; Shift+Enter quebra linha)
//  - auto-resize do textarea conforme o conteudo
//  - reset da caixa apos o envio (turbo:submit-end)
//  - autoscroll para o fim quando chega novo conteudo na thread (MutationObserver)
//
// Data attributes esperados:
//  data-controller="chat" no container
//  data-chat-target="form"     -> o <form> da caixa de entrada
//  data-chat-target="input"    -> o <textarea>
//  data-chat-target="messages" -> o container das bolhas (so existe na thread)
//  data-action="keydown->chat#handleKey input->chat#autoResize" no textarea
//  data-action="turbo:submit-end->chat#reset" no form
export default class extends Controller {
  static targets = ["form", "input", "messages"]

  connect() {
    this.scrollToBottom()
  }

  messagesTargetConnected(element) {
    this.scrollToBottom()
    this.observer = new MutationObserver(() => this.scrollToBottom())
    this.observer.observe(element, { childList: true, subtree: true })
  }

  messagesTargetDisconnected() {
    this.observer?.disconnect()
  }

  handleKey(event) {
    if (event.key === "Enter" && !event.shiftKey) {
      event.preventDefault()
      if (this.inputTarget.value.trim()) {
        this.formTarget.requestSubmit()
      }
    }
  }

  autoResize() {
    const el = this.inputTarget
    el.style.height = "auto"
    el.style.height = Math.min(el.scrollHeight, 160) + "px"
  }

  reset() {
    this.inputTarget.value = ""
    this.inputTarget.style.height = "auto"
    this.inputTarget.focus()
  }

  scrollToBottom() {
    if (this.hasMessagesTarget) {
      this.messagesTarget.scrollTop = this.messagesTarget.scrollHeight
    }
  }
}
